function convertToFlatpickrFormat(format) {
  let newFormat = 'Y/m/d H\\hi';

  if (format !== undefined) {
    newFormat = format
      .replace('YYYY', 'Y')
      .replace('MM', 'm')
      .replace('DD', 'd')
      .replace('HH', 'H')
      .replace('mm', 'i')
      .replace('ss', 'S');

    const escapeGroup = newFormat.match(/\[.*?\]/gm);
    if (escapeGroup !== null) {
      for (const txt of escapeGroup) {
        newFormat = newFormat.replace(
          txt,
          `\\${txt.substring(1, txt.length - 1)}`
        );
      }
    }
  }

  return newFormat;
}

export { convertToFlatpickrFormat }